import { render, staticRenderFns } from "./AuthSetter.vue?vue&type=template&id=218e82b4&"
import script from "./AuthSetter.vue?vue&type=script&lang=js&"
export * from "./AuthSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports